import React, { useState, useEffect } from 'react';
import { Box, Grid, Typography, Button, FormControl, Select, MenuItem, FormHelperText, Chip } from '@mui/material';
import { TextField, CustomCheckbox } from '../../../MUI_custom_component';
import { calculateAgesAndFlags, getAge, ReusableOCRFlow } from '../../../../v3/Common/OCR';
import { AdhaarOCRVerficiationAction, PanOCRVerificationAction } from '../../../../v3/Beneficiary/StaffInsurance/APIs/action';
import { UserFileDict } from '../../../../utils/settings';

const NomineeOCRForm = ({ 
    nominee, 
    onFieldChange,
    relations = [],
    errors = {},
    onSubmit,
    submitLoader = false,
    confirmation_text = '',
    onCancel,
    selectedDocumentType = 'AADHAAR',
    resetTrigger = 0,
    onDocumentTypeChange
}) => {
    const handleOCRSuccess = (extractedData) => {
        console.log('OCR Success - extracted data:', extractedData);
        const calculatedAge = extractedData.dob ? getAge(extractedData.dob) : null;
        const processedData = {
            ...extractedData,
            age: calculatedAge,
            id_type: selectedDocumentType === 'PAN' ? UserFileDict.PAN_CARD : UserFileDict.AADHAR_CARD
        };
        console.log('OCR Success - processed data:', processedData);
        if (onFieldChange) {
            console.log('OCR Success - calling onFieldChange with:', processedData);
            onFieldChange(processedData);
        }
    };

    const handleSave = async (formData) => {
        const calculatedAge = formData.dob ? getAge(formData.dob) : null;
        const nomineeData = {
            ...formData,
            age: calculatedAge,
            id_number: formData.id_number || '',
            id_type: selectedDocumentType === 'PAN' ? UserFileDict.PAN_CARD : UserFileDict.AADHAR_CARD
        };
        if (onFieldChange) {
            onFieldChange(nomineeData);
        }
        if(onSubmit){
            await onSubmit(nomineeData);
        }
    };
    
    const aadhaarExtractor = (data) => ({
        full_name: data.name || '',
        dob: data.date_of_birth || '',
        gender: data.gender || '',
        id_number: data.document_id || '',
        document_type: 'AADHAAR'
    });

    // Custom data extractor for PAN OCR response
    const panExtractor = (data) => ({
        full_name: data.name || '',
        dob: data.date_of_birth || '',
        id_number: data.document_id || '',
        document_type: 'PAN'
    });
    // Select the appropriate OCR service and extractor based on document type
    const ocrService = selectedDocumentType === 'PAN' ? PanOCRVerificationAction : AdhaarOCRVerficiationAction;
    const extractorFunction = selectedDocumentType === 'PAN' ? panExtractor : aadhaarExtractor;
    const uploadTitle = selectedDocumentType === 'PAN' ? 'Upload Beneficiary PAN' : 'Upload Beneficiary Aadhar';
    const processingText = selectedDocumentType === 'PAN' ? 'Processing PAN...' : 'Processing Aadhar...';

    // Additional fields for PAN document type (gender dropdown)
    const additionalFields = selectedDocumentType === 'PAN' ? [
        {
            type: 'select',
            name: 'gender',
            label: 'Gender',
            placeholder: 'Select Gender',
            required: true,
            defaultValue: 'MALE', // Select first gender by default
            options: [
                { value: 'MALE', label: 'Male' },
                { value: 'FEMALE', label: 'Female' }
            ]
        }
    ] : [];
    return (
        <Box>
            <ReusableOCRFlow
                ocrService={ocrService}
                extractorFunction={extractorFunction}
                title="Add Nominee Details"
                uploadTitle={uploadTitle}
                processingText={processingText}
                context="nominee"
                requirePhone={true}
                requireEmail={false}
                requireRelation={true}
                relations={relations}
                onSave={handleSave}
                onSuccess={handleOCRSuccess}
                onCancel={onCancel}
                confirmModalTitle="Confirm Nominee Details"
                manualFormTitle="Enter Nominee Details Manually"
                onFieldChange={onFieldChange}
                additionalFields={additionalFields}
                resetTrigger={resetTrigger}
                showDocumentTypeSelection={true}
                selectedDocumentType={selectedDocumentType}
                onDocumentTypeChange={onDocumentTypeChange}
                relationData={nominee.relation}
            />
        </Box>
    );
};

export default NomineeOCRForm;